import {filterSvg as Icon__small__filterSvg} from '../Icon__small/Icon__small--filter.js';
import {filterSvg as Icon__xsmall__filterSvg} from '../Icon__xsmall/Icon__xsmall--filter.js';

export var filter = {
  name: 'filter',
  category: 'icon',
  colorable: true,
  svg: Icon__small__filterSvg,
  alt: {
    Icon__small: Icon__small__filterSvg,
    Icon__xsmall: Icon__xsmall__filterSvg,
  },
  combined: ['Icon__small', 'Icon__xsmall'],
};
